import React from "react";
import { EmptyBox } from "../../assets/icons/icon";

const NotFound = () => {
  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "12px",
        }}
      >
        <EmptyBox />
        <p>No Data Found</p>
      </div>
    </div>
  );
};

export default NotFound;
